module.exports = __webpack_public_path__ + "assets/2uN-G2jrIZ.woff";